import React, { useContext, useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import style from "./Consent.module.scss";
import { MessageContext, getMessage, Message } from "@messageformat/react";

export const Consent = () => {
  const [cookieDialogVisible, setCookieDialogVisible] = useState(false);
  const messageContext = useContext(MessageContext);

  useEffect(() => {
    if (!window.isCookieConsentAccepted()) {
      setCookieDialogVisible(true);
    }
  }, []);

  if (!cookieDialogVisible) {
    return null;
  }

  return (
    <div className={style.container}>
      <h2>
        <Message id="consent.title" />
      </h2>
      <p
        dangerouslySetInnerHTML={{
          __html: getMessage(messageContext, "consent.description")(),
        }}
      />
      <div style={{ display: "flex", flexDirection: "row-reverse" }}>
        <button
          className={style.consent}
          onClick={() => {
            setCookieDialogVisible(false);
            window.acceptCookieConsent();
          }}
        >
          <Message id="consent.accept" />
        </button>
      </div>
      <button
        className={style.close}
        title={getMessage(messageContext, "consent.close")}
        onClick={() => setCookieDialogVisible(false)}
      >
        <FaTimes />
      </button>
    </div>
  );
};
